module.exports = __webpack_public_path__ + "static/img/img21.81a88780.png";